/**
 * nimbus-shipping-geo.js
 * Uses Shopify's /browsing_context_suggestions.json for real IP geo-detection.
 * Updates all .sb-ship-txt elements to the correct shipping threshold.
 *
 * High-threshold : HU, IL  → data-high
 * USA            : US       → data-us
 * Everything else           → data-eu (already the server-side default — no update needed)
 */
(function () {
  var HIGH = ['HU', 'IL'];

  function applyCountry(country) {
    if (!country) return;
    country = country.toUpperCase();

    var group = HIGH.indexOf(country) !== -1 ? 'high' : country === 'US' ? 'us' : 'eu';
    if (group === 'eu') return; // server-side default is already EU

    document.querySelectorAll('.sb-ship-txt').forEach(function (el) {
      var val = el.getAttribute('data-' + group);
      if (val) el.innerHTML = val;
    });
  }

  fetch('/browsing_context_suggestions.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var country =
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle;
      applyCountry(country);
    })
    .catch(function () {
      // Silent fail — server-side EU default stays visible
    });
})();
